// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2uz8a","detailsBorder":"styles_detailsBorder__2MvDm"};